import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Box, Toolbar } from "@mui/material";
import { useEffect, useState } from "react";
import sizeConfigs from "../../configs/sizeConfigs";
import Sidebar from "../common/Sidebar";
import FolderIcon from '@mui/icons-material/Folder';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import backgroundimage from '../../assets/images/backgroundimage.jpg';

const colorConfigs = {
  sidebar: {
    bg: "#233044",
    color: "#eeeeee",
    hoverBg: "#1e293a",
    activeBg: "#1e253a"
  },
  topbar: {
    bg: "#fff",
    color: "#000"
  },
  mainBg: `url(${backgroundimage})`
};

const MainLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuItems, setMenuItems] = useState<any[]>([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check authentication and load menu items
  useEffect(() => {
    const checkAuthAndLoadMenu = () => {
      const userData = localStorage.getItem('userdata');
      
      if (!userData) {
        navigate("/", { replace: true });
        return;
      }

      try {
        const items2 = JSON.parse(userData);
        if (!items2 || !items2.length) {
          navigate("/", { replace: true });
          return;
        }

        const items1 = items2[0]?.userPermission?.[0]?.parentMenu || [];
        const processedMenu = processMenuItems(items1);
        setMenuItems(processedMenu);
        setIsAuthenticated(true);
      } catch (error) {
        console.error("Error parsing user data:", error);
        navigate("/", { replace: true });
      }
    };

    checkAuthAndLoadMenu();
  }, [navigate]);

  const processMenuItems = (parentMenu: any[]) => {
    return parentMenu
      .map(parent => ({
        id: parent.menuId,
        name: parent.menuName,
        label: parent.menuName,
        displayNo: parent.displayNo,
        path: '',
        Icon: FolderIcon,
        items: (parent.childMenu || [])
          .map((child:any) => ({
            id: child.menuId,
            name: child.menuName,
            label: child.menuName,
            path: child.path,
            displayNo: child.displayNo,
            Icon: TouchAppIcon,
            onClick: (e: any) => handleMenuItemClick(e, child)
          }))
          .sort((a:any, b:any) => a.displayNo - b.displayNo)
      }))
      .sort((a, b) => a.displayNo - b.displayNo);
  };

  const handleMenuItemClick = (e: any, item: any) => {
    e.preventDefault();
    const path = item.path;
    
    if (!path) {
      console.warn("Path not found for menu item:", item);
      return;
    }
    
    navigate(path);
  };

  if (location.pathname === "/") {
    return <Outlet />;
  }

  if (!isAuthenticated) {
    return null; // Or a loading spinner
  }

  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar items={menuItems} />
      
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          px: 1,
          py: 2,
          width: `calc(100% - ${sizeConfigs.sidebar.width})`,
          minHeight: "100vh",
          backgroundColor: "rgba(229, 228, 226, 0.9)",
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;